module.exports = __webpack_public_path__ + "img/delete_outline.87cbed57.svg";